import script from "./item_two.vue?vue&type=script&setup=true&lang=js"
export * from "./item_two.vue?vue&type=script&setup=true&lang=js"

import "./item_two.vue?vue&type=style&index=0&id=145bb73b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145bb73b"]])

export default __exports__